import React, { Fragment } from 'react'
import { connect } from 'react-redux';
import { Modal, Button, Select, Form, Row, Col, Input, Radio, Card } from 'antd';
import ImageUpload from '../../../containers/ImageUpload';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const formItemLayout = {
    // labelCol: {
    //     xs: { span: 24 },
    //     sm: { span: 4 },
    // },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};
class ProductSkuModal extends React.Component {
    initState = {
        loading: false,
        error: [],

        id: null,
        external_product_sku_id: null,
        image: [],
        // view: null,
        product_sku_language_list: [],
        attr_1: '',
        weight: 0,
        width: 0,
        height: 0,
        length: 0,
        // total: 0,
        // purchase: 0,
        inventory: 0,
        product_point: 0,
        price: 0,
        price_for_sale: 0,
    }

    constructor(props) {
        super(props);
        this.state = this.initState
    }
    componentWillReceiveProps(nextProps) {
        let _item;
        let item = nextProps.productSkuCurrentItem ? nextProps.productSkuCurrentItem : false
        let detailList = []
        this.props.languageList.map(item=>{
            detailList.push({ 
                attr_1: '',
                image: '',
                imageList: [],
                language_id: item.id
             })
        })
        if (!item) {
            _item = {
                id: null,
                external_product_sku_id: null,
                // image: [],
                // view: '',
                // attr_1: '',
                weight: 0,
                width: 0,
                height: 0,
                length: 0,
                // total: 0,
                // purchase: 0,
                inventory: 0,
                product_point: 0,
                price: 0,
                price_for_sale: 0,
                product_sku_language_list: item.product_sku_language_list || detailList
            }
        } else {
            _item = {
                id: item.id,
                external_product_sku_id: item.external_product_sku_id,
                // image: item.image,
                // view: item.view,
                // attr_1: item.attr_1,
                weight: item.weight | 0,
                width: item.width | 0,
                height: item.height | 0,
                length: item.length | 0,
                // total: item.total | 0,
                // purchase: item.purchase | 0,
                inventory: item.inventory | 0,
                product_point: item.product_point | 0,
                price: item.price | 0,
                price_for_sale: item.price_for_sale | 0,
                product_sku_language_list: item.product_sku_language_list || detailList
            }
        }
        this.setState(_item)
        this.initInput(_item)

    }
    initInput = (item) => {
        // console.log("itemitemitemitemitem:", item)
        // product_sku_language_list
        let thisScope = this
        // let detailListProductSku = []
        // this.props.languageList.map(item=>{
        //     detailListProductSku.push({ 
        //         attr_1: '',
        //         image: '',
        //         language_id: item.id
        //      })
        // })

        // this.setState({
        //     product_sku_language_list: detailListProductSku,
        // })

        setTimeout(() => {
            thisScope.setState({
                id: item.id,
                external_product_sku_id: item.external_product_sku_id,
                image: item.image,
                // attr_1: item.attr_1,
                weight: item.weight,
                width: item.width,
                height: item.height,
                length: item.length,
                // total: item.total,
                // purchase: item.purchase,
                inventory: item.inventory,
                product_point: item.product_point,
                price: item.price,
                price_for_sale: item.price_for_sale,
                product_sku_language_list: item.product_sku_language_list,
            });
        }, 100);
    }
    handleOk() {
        const { id, image, external_product_sku_id, attr_1, weight, total, purchase, inventory, product_point, price, price_for_sale, width, height, length,
            product_sku_language_list
         } = this.state
        const { productSkuCurrentItem } = this.props
        const value = {
            id: id,
            image: image && image.length > 0 ? image : [],
            // view: image && image.length > 0 && image[0].view ? image.view : null,
            external_product_sku_id: external_product_sku_id,
            // attr_1: attr_1,
            weight: weight,
            width: width,
            height: height,
            length: length,
            // total: total,
            // purchase: purchase,
            inventory: inventory,
            product_point: product_point,
            price: price,
            price_for_sale: price_for_sale,
            product_sku_language_list: product_sku_language_list
        }
        // let int = productSkuCurrentItem ? productSkuCurrentItem.index : false
        this.props.handleOk(value, productSkuCurrentItem ? productSkuCurrentItem.index : false)
    }
    handleCancel() {
        this.props.onClose()
    }

    updateNameLanguage(index, name, value) {
        let product_sku_language_list = this.state.product_sku_language_list.map(item => Object.assign({}, item))
        product_sku_language_list[index][name] = value
        this.setState({ product_sku_language_list: product_sku_language_list })
    }

    render() {
        const { visible, isNotUsePriceForAllProduct, isUsePointIndividuallySku, productTitleName, attr_1 } = this.props;
        const { loading, product_point, width, height, length } = this.state;
        return (
            <div>
                <Modal
                    width='50vw'
                    visible={visible}
                    title={'Product SKU'}
                    onCancel={() => this.handleCancel()}
                    footer={[
                        <Button key="submit"
                            type="primary"
                            size="large"
                            loading={loading}
                            onClick={() => this.handleOk()}
                        // disabled={this.state.status == 'show' ? true : false} 
                        >
                            {"Save"}
                            {/* {this.renderText('course_page', 'save', 'Save')} */}
                        </Button>,
                    ]}
                >
                    <Form className='product-sku-modal-align-left'>
                        {/* <Row>
                            <Col sm={24} md={24} lg={24} style={{ flexDirection: 'row' }}>
                                <FormItem {...formItemLayout} label={'Product SKU image'}>
                                    <ImageUpload
                                        label={'Upload product SKU image'}
                                        limit={1}
                                        dataSource={this.state.image}
                                        // previewImage={productSkuCurrentItem ? this.state.view : null}
                                        updateDataSource={(dataSource) => this.setState({ image: dataSource })}
                                    />
                                </FormItem>
                            </Col>
                        </Row> */}
                        <Row gutter={24}>
                            {/* <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} required label={productTitleName ? productTitleName : "Name"}>
                                    <Input
                                        value={this.state.attr_1}
                                        onChange={(event) => this.setState({ attr_1: event.target.value })}
                                    />
                                </FormItem>
                            </Col> */}
                            {this.state.product_sku_language_list.map((item, index) => {
                                return (
                                    <Card style={{ marginBottom: 10 }}>
                                        <Row>
                                            <Col sm={24} md={24} lg={24} style={{ flexDirection: 'row' }}>
                                                <FormItem {...formItemLayout} label={'Product SKU image'}>
                                                    <ImageUpload
                                                        label={'Upload product SKU image'}
                                                        limit={1}
                                                        // dataSource={this.state.image}
                                                        dataSource={item.imageList}
                                                        // previewImage={productSkuCurrentItem ? this.state.view : null}
                                                        // updateDataSource={(dataSource) => this.setState({ image: dataSource })}
                                                        updateDataSource={(dataSource) => this.updateNameLanguage(index, 'imageList', dataSource)}
                                                    />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                        <Row gutter={24}>
                                            <Col xs={24} sm={24} md={6} lg={6} xl={6} >
                                                <FormItem {...formItemLayout} label={'Line ID'}>
                                                    <p style={{ margin: 0, fontSize: 14, padding: 3 }}>{`0000${index + 1}`}</p>
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} sm={24} md={8} lg={8} xl={8} >
                                                <FormItem {...formItemLayout} label={'Language'} required={true}>
                                                    <Select
                                                        allowClear={true}
                                                        value={item.language_id}
                                                        onChange={(value) => this.updateNameLanguage(index, 'language_id', value)}
                                                    >
                                                        {this.props.languageList.length ?
                                                            this.props.languageList.map((item, index) =>
                                                                <Option
                                                                    key={index}
                                                                    value={item.id}
                                                                    disabled={this.state.product_sku_language_list.map(r => r.language_id).includes(item.id)}
                                                                >
                                                                    {item.name}
                                                                </Option>)
                                                            : null}
                                                    </Select>
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} sm={24} md={10} lg={10} xl={10} >
                                                <FormItem {...formItemLayout} label={'Name'} required={true}>
                                                    <Input
                                                        value={item.attr_1}
                                                        onChange={(event) => this.updateNameLanguage(index, 'attr_1', event.target.value)}
                                                    />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Card>
                                )
                            })}
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Weight"}>
                                    <Input
                                        value={this.state.weight}
                                        type={'number'}
                                        onChange={(event) => this.setState({ weight: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Width"}>
                                    <Input
                                        value={width}
                                        type={'number'}
                                        onChange={(event) => this.setState({ width: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Length"}>
                                    <Input
                                        value={length}
                                        type={'number'}
                                        onChange={(event) => this.setState({ length: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Height"}>
                                    <Input
                                        value={height}
                                        type={'number'}
                                        onChange={(event) => this.setState({ height: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            {/* <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Total"}>
                                    <Input
                                        value={this.state.total}
                                        type={'number'}
                                        onChange={(event) => this.setState({ total: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Purchase"}>
                                    <Input
                                        value={this.state.purchase}
                                        type={'number'}
                                        onChange={(event) => this.setState({ purchase: event.target.value })}
                                    />
                                </FormItem>
                            </Col> */}
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Inventory"}>
                                    <Input
                                        value={this.state.inventory}
                                        type={'number'}
                                        onChange={(event) => this.setState({ inventory: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Point"}>
                                    <Input
                                        disabled={!isUsePointIndividuallySku}
                                        value={product_point}
                                        type={'number'}
                                        onChange={(event) => this.setState({ product_point: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Price"}>
                                    <Input
                                        disabled={!isNotUsePriceForAllProduct}
                                        value={this.state.price}
                                        type={'number'}
                                        onChange={(event) => this.setState({ price: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                            <Col sm={24} md={12} lg={6}>
                                <FormItem {...formItemLayout} label={"Price For Sale"}>
                                    <Input
                                        disabled={!isNotUsePriceForAllProduct}
                                        value={this.state.price_for_sale}
                                        type={'number'}
                                        onChange={(event) => this.setState({ price_for_sale: event.target.value })}
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <ul>
                        {this.state.error.map((item, index) => {
                            return (<li style={{ color: 'red' }} key={index}>{item}</li>)
                        })}
                    </ul>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    languageList: state.customerLanguage.languageList,

})

export default connect(mapStateToProps)(ProductSkuModal);